import { IOfferListTableLang } from '../../../types/lang'

export const offerListTableLang: IOfferListTableLang = {
	offer_list_table: {
		column_id: 'ID',
		column_name: 'Name',
		column_affiliate_network: 'Affiliate Network',
		column_country: 'Country',
	}
}